import Vue from 'vue'
import Cookie from 'js-cookie'
import moment from 'moment'

function contractDataReceived(state, response) {
  const data = response.data.list.find((contract) => {
    return contract.get_vertrag.cubeidentifier === state.cube.name
  })

  const contract = data.get_vertrag
  const customer = data.get_vertrag.get_kunde
  const cubeAddress = data.get_lieferadresse
  const billingAddress = data.get_vertrag.get_kunde.get_adressen[0]

  Vue.set(state.settings.contractData, 'meterPointId', data.zaehlpunktnummer)
  Vue.set(state.settings.contractData, 'contractId', contract.vertragsnummer)
  Vue.set(state.settings.contractData, 'fullName', customer.name)
  Vue.set(state.settings.contractData, 'nickName', contract.nickname)
  Vue.set(state.settings.contractData, 'phone', customer.telefon)
  Vue.set(state.settings.contractData, 'email', customer.email)

  Vue.set(
    state.settings.contractData.cubeAddress,
    'address',
    cubeAddress.strasse
  )
  Vue.set(state.settings.contractData.cubeAddress, 'zip', cubeAddress.plz)
  Vue.set(state.settings.contractData.cubeAddress, 'city', cubeAddress.ort)
  Vue.set(
    state.settings.contractData.cubeAddress,
    'country',
    cubeAddress.land_bezeichnung
  )

  Vue.set(
    state.settings.contractData.billingAddress,
    'address',
    billingAddress.strasse
  )
  Vue.set(state.settings.contractData.billingAddress, 'zip', billingAddress.plz)
  Vue.set(
    state.settings.contractData.billingAddress,
    'city',
    billingAddress.ort
  )
  Vue.set(
    state.settings.contractData.billingAddress,
    'country',
    billingAddress.land_bezeichnung
  )
}

function selectInvoiceYear(state, year) {
  Vue.set(state.settings, 'selectedInvoiceYear', year)
}

function consumersPricesReceived(state, data) {
  const consumerPrices = data.data.list.reduce((result, row) => {
    const cubeName = row.cubeidentifiers[0]
    if (!result[cubeName]) {
      result[cubeName] = {}
    }

    const price = parseFloat(row.preis)
    if (row.zeittyp === 'aktuell') {
      result[cubeName].currentPrice = price
    } else if (row.zeittyp === 'next') {
      result[cubeName].nextPrice = price
      result[cubeName].dateNextPrice = moment(row.gueltig_ab, 'X').toDate()
    }

    return result
  }, {})

  Vue.set(state.cube, 'consumerPrices', consumerPrices)
}

function updateConsumerPrice(state, data) {
  state.cube.consumerPrices[data.cubeName] = {
    currentPrice: data.currentPrice,
    nextPrice: data.nextPrice,
    dateNextPrice: data.dateNextPrice,
  }
}

function producerPricesReceived(state, data) {
  const errors = []

  data.data.list.map((row) => {
    const cubeName = row.get_artikel.artikelnr
    if (Object.prototype.hasOwnProperty.call(row, 'preis')) {
      if (row.zeittyp === 'aktuell') {
        if (!state.map.globalProducerPrices[cubeName]) {
          // The app needs to display prices for consumers including vat. Since the
          // reem api does not handle this atm we take this into account here.
          Vue.set(state.map.globalProducerPrices, cubeName, {
            currentPrice: parseFloat(row.preis) * state.global.vatFactor,
          })
        }

        Vue.set(
          state.map.globalProducerPrices[cubeName],
          'currentPrice',
          parseFloat(row.preis) * state.global.vatFactor
        )
      } else if (row.zeittyp === 'next') {
        if (!state.map.globalProducerPrices[cubeName]) {
          Vue.set(state.map.globalProducerPrices, cubeName, {
            nextPrice: parseFloat(row.preis) * state.global.vatFactor,
            dateNextPrice: moment(row.gueltig_ab, 'X').toDate(),
          })
        } else {
          Vue.set(
            state.map.globalProducerPrices[cubeName],
            'nextPrice',
            parseFloat(row.preis) * state.global.vatFactor
          )
          Vue.set(
            state.map.globalProducerPrices[cubeName],
            'dateNextPrice',
            moment(row.gueltig_ab, 'X').toDate()
          )
        }
      }
    } else {
      errors.push(row)
    }
  })

  if (errors.length > 0) throw `price is falsy: ${JSON.stringify(errors)}`
}

function setDefaultSellingPrices(state, data) {
  Vue.set(
    state.settings.producerSettings,
    'defaultSellingPrice',
    data.currentPrice
  )
  Vue.set(
    state.settings.producerSettings.nextDefaultSellingPrice,
    'price',
    data.nextPrice
  )
  Vue.set(
    state.settings.producerSettings.nextDefaultSellingPrice,
    'date',
    data.dateNextPrice
  )
}

function invoicesReceived(state, data) {
  const contractId = state.settings.contractData.contractId
  const contract = data.list.find((c) => {
    return c.vertragsnummer === contractId
  })
  let invoices = []

  contract.get_rechnungen_simple.map((rawInvoice) => {
    invoices.push({
      name: rawInvoice.nummer,
      url: rawInvoice.get_dokumenteliste.pop().get_dokument_httplink,
      date: new Date(parseInt(rawInvoice.datum, 10) * 1000),
    })
  })

  Vue.set(state.settings, 'invoices', invoices)
}

function removeSpecialPriceForConsumer(state, data) {
  Vue.delete(state.cube.consumerPrices, data.cubeName)
}

function passwordResetProcessStarted(state, message) {
  // When a user triggers the password reset process we store the current
  // datetime in a cookie and read it into the store when initializing.
  // We only allow password resets after a certain amount of time has passed.
  // See Util.js:canDoPasswordReset().
  const now = Math.floor(Date.now() / 1000)
  Cookie.set('lastPasswordReset', now, {
    expires: 1,
    secure: true,
  })
  Vue.set(state.forms.passwordReset, 'message', message)
  Vue.set(state.forms.changePassword, 'message', message)
}

function setFormMessage(state, data) {
  Vue.set(state.forms[data.form], 'message', data.message)
}

export default {
  contractDataReceived,
  selectInvoiceYear,
  consumersPricesReceived,
  producerPricesReceived,
  setDefaultSellingPrices,
  updateConsumerPrice,
  invoicesReceived,
  removeSpecialPriceForConsumer,
  passwordResetProcessStarted,
  setFormMessage,
}
